import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UtilService {
    private idleMsnTiempoAgotado = new Subject<string>();
    public displaySpinner: boolean;
    public displayIdle: boolean;

    constructor() {
        this.idleMsnTiempoAgotado.next('');
    }

    setidleMsnTiempoAgotado(msn: string) {
        this.idleMsnTiempoAgotado.next(msn);
    }

    getIdleMsnTiempoAgotado(): Observable<string> {
        return this.idleMsnTiempoAgotado.asObservable();
    }
}
